import { lastValueFrom } from 'rxjs';
import { CollaboratorRepositoryImplementation } from '../infrastructure/collaborator-repository-implementation';
import { CollaboratorCreateDTO, CollaboratorUpdateDTO } from '../domain/collaborator/entity';

const collaboratorRepository = new CollaboratorRepositoryImplementation();

export const getCollaborators = async (uid: string, cid: string | null) => {
    return await lastValueFrom(collaboratorRepository.list(uid, cid));
};

export const createCollaborator = async (uid: string, cid: string | null, data: CollaboratorCreateDTO) => {
    return await lastValueFrom(collaboratorRepository.create(uid, cid, data));
};

export const updateCollaborator = async (uid: string, cid: string | null, id: number, data: CollaboratorUpdateDTO) => {
    return await lastValueFrom(collaboratorRepository.update(uid, cid, id, data));
};

export const deleteCollaborator = async (uid: string, cid: string | null, id: number) => {
    return await lastValueFrom(collaboratorRepository.delete(uid, cid, id));
};
